import TabNav from "components/TabNav";
import { useAuth } from "contexts/AuthContext";
import { useToast } from "contexts/ToastContext";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getInternalLegalResearchRequest } from "services/legalResearchService";
import {
    LEGAL_RESEARCH_PROSECUTOR_TAB,
    LEGAL_RESEARCH_PROSECUTOR_TABS, LEGAL_RESEARCH_REQUEST_STATUS,
} from "utils/constantValues";
import InternalLeftPanel from "./internalLeftPanel";
import InternalRegistrarLegalResearch from "./internalRegistrarLegalResearch";
import LeftPanel from "./leftPanel";
import RightPanel from "./rightPanel";


const InternalConductLegalResearch = () => {
    const [activeTab, setActiveTab] = useState<string>("Proposal Document");
    const { showToast } = useToast();
    const contextData = useAuth();
    const [formState, setFormState] = useState<any>({});
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        const fetchRequest = async () => {
            try {
                const data = await getInternalLegalResearchRequest(contextData.token, id || "");
                setFormState(data);
                console.log("formState data (from API):", data);
            } catch (error) {
                console.error("Error fetching internal legal research request:", error);
                showToast("Failed to fetch internal legal research request.", "error");
            }
        };

        if (contextData?.token && id) {
            fetchRequest();
        }
    }, [contextData?.token, id]);

    useEffect(() => {
        console.log("formState updated:", formState);
    }, [formState]);

    // Registrar sees the document (left) panel — Proposal Document / Legal Research tabs —
    // but not the feedback/respondback (right) panel.
    const isRegistrar = contextData?.user?.roles?.some((p: string) => p?.toLowerCase().includes("registrar"));

    return (
        <div className="flex flex-col h-full bg-gray-100">
            <TabNav
                active={activeTab}
                tabs={isRegistrar || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.research_underway.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_submitted.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_revision.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_approved.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.completed.value || formState?.documents?.find((document: any) => document.document_type === "research_draft_file") ?
                    LEGAL_RESEARCH_PROSECUTOR_TABS : LEGAL_RESEARCH_PROSECUTOR_TAB}
                onSelect={setActiveTab}
            />
            <div className="flex flex-1 overflow-hidden">
                {isRegistrar ? (
                    <>
                        <div className="flex flex-1 max-w-4xl overflow-hidden">
                            <InternalLeftPanel activeTab={activeTab} request={formState} />
                        </div>
                        <InternalRegistrarLegalResearch request={formState} />
                    </>
                ) : (
                    <>
                        <InternalLeftPanel activeTab={activeTab} request={formState} />
                        <RightPanel request={formState} />
                    </>
                )}
            </div>
        </div>
    );
};

export default InternalConductLegalResearch;

